import { httpClient } from '@/services/http/httpClient'

type GetPublicPortfolioIdResponse = {
  id: string
  title: string
  description: string
}

export async function getPublicPortfolioId(id: string) {
  const { data } = await httpClient.get<GetPublicPortfolioIdResponse>(
    `/projects/portfolios/public/${id}`,
  )

  return data
}
